import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { Change } from './queries/useSearchChangesetChanges.query';
import { ChangeSetLogs } from './ChangeSetLogs';

interface Props {
  groupedLogs: Change[][];
  isBulkUpdate?: boolean;
}

export const GroupedChangeSetLogs: React.FC<Props> = ({ groupedLogs, isBulkUpdate }) => (
  <Box data-testId="GroupedChangeSetLogs">
    <Box background="module" round="small">
      <Box>
        <Box>
          <Box
            height="32px"
            background="legend"
            round="8px"
            pad={{ vertical: '7px', horizontal: 'spacing12' }}
            direction="row"
            align="center"
          >
            <Box width="26%"><Inscription size="12px" weight="bold">Attribute</Inscription></Box>
            <Box width="37%" pad={{ left: 'spacing24' }}><Inscription size="12px" weight="bold">Previous</Inscription></Box>
            <Box width="37%" pad={{ left: '36px' }}><Inscription size="12px" weight="bold">Updated</Inscription></Box>
          </Box>
        </Box>

        {groupedLogs?.map((logs, index) => (
          <ChangeSetLogs
            key={logs?.[0]?.uniqueGroupId || `group-${index}`}
            logs={logs}
            isBulkUpdate={isBulkUpdate}
          />
        ))}
      </Box>
    </Box>
  </Box>
);
